var _defs, _rect, _rect2, _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #0032ff;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.33,
    y: 26.24,
    width: 262.34,
    height: 147.53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.65,
    y: 69.26,
    width: 11.64,
    height: 54.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.21,114.02h11.57c2.81,0,5.07-.57,6.78-1.72,1.71-1.15,2.57-2.86,2.57-5.16,0-2.29-.86-4.04-2.57-5.23-1.71-1.2-3.97-1.8-6.78-1.8h-11.57s0,13.9,0,13.9ZM84.21,91.71h9.19c2.86,0,5.15-.56,6.86-1.68,1.71-1.12,2.57-2.72,2.57-4.81,0-2.24-.83-3.88-2.49-4.93-1.66-1.04-3.97-1.56-6.93-1.56h-9.19s0,12.98,0,12.98ZM72.57,123.49v-54.23s21.15,0,21.15,0c6.74,0,11.9,1.18,15.48,3.55,3.57,2.37,5.36,6.1,5.36,11.19,0,2.24-.46,4.19-1.38,5.84-.92,1.66-2.26,2.97-4.02,3.93-1.76.97-3.9,1.55-6.4,1.76v-.15c4.55.31,8.03,1.62,10.46,3.93,2.42,2.32,3.64,5.38,3.64,9.2,0,5.04-1.78,8.8-5.32,11.26-3.55,2.47-8.62,3.7-15.21,3.7h-23.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.64,114.93c3.06,0,5.68-.72,7.85-2.18,2.17-1.45,3.83-3.55,4.98-6.3,1.15-2.75,1.72-6.08,1.72-10s-.57-7.27-1.72-10.04c-1.15-2.77-2.81-4.9-4.98-6.38-2.17-1.48-4.79-2.22-7.85-2.22s-5.59.74-7.74,2.22c-2.14,1.48-3.79,3.6-4.94,6.38-1.15,2.78-1.72,6.12-1.72,10.04,0,3.92.57,7.26,1.72,10,1.15,2.75,2.81,4.85,4.98,6.3,2.17,1.45,4.74,2.18,7.7,2.18M149.72,124.71c-5.52,0-10.25-1.15-14.21-3.44-3.96-2.29-7-5.55-9.12-9.78-2.12-4.23-3.18-9.24-3.18-15.05,0-5.81,1.06-10.83,3.18-15.08,2.12-4.25,5.16-7.54,9.12-9.85,3.96-2.32,8.7-3.48,14.21-3.48,5.57,0,10.32,1.16,14.25,3.48,3.93,2.32,6.96,5.6,9.08,9.85,2.12,4.25,3.18,9.28,3.18,15.08,0,5.8-1.06,10.82-3.18,15.05-2.12,4.23-5.16,7.48-9.12,9.78-3.96,2.29-8.7,3.44-14.21,3.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.53,95h9.42c3.06,0,5.44-.67,7.12-2.02,1.69-1.35,2.53-3.35,2.53-6,0-2.6-.83-4.57-2.49-5.92-1.66-1.35-4.05-2.02-7.16-2.02h-9.42s0,15.96,0,15.96ZM183.89,123.49v-54.23s21.76,0,21.76,0c6.54,0,11.66,1.58,15.36,4.74,3.7,3.16,5.55,7.48,5.55,12.98,0,3.62-.83,6.76-2.49,9.43-1.66,2.67-4.06,4.74-7.2,6.19-3.14,1.45-6.88,2.18-11.22,2.18h-10.11s0,18.71,0,18.71h-11.65Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "233.84 123.49 233.84 69.26 271.69 69.26 271.69 79.03 245.49 79.03 245.49 91.48 270.77 91.48 270.77 101.11 245.49 101.11 245.49 113.71 272.3 113.71 272.3 123.49 233.84 123.49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbope);
export default __webpack_public_path__ + "static/media/IBOPE.07b74fd7dd33960e785c1540190b15b4.svg";
export { ForwardRef as ReactComponent };